/**
 * Authentication utility functions
 */

/**
 * Checks if authentication is required based on the current URL hostname
 * @returns {boolean} True if authentication is required, false otherwise
 */
export const isAuthenticationRequired = (): boolean => {
    const currentUrl = window.location.hostname;
    return currentUrl.includes('mactest.netkom.it');
};

/**
 * Checks if the current environment is localhost
 * @returns {boolean} True if running on localhost, false otherwise
 */
export const isLocalhost = (): boolean => {
    const currentUrl = window.location.hostname;
    return currentUrl === 'localhost' || currentUrl === '127.0.0.1' || currentUrl.startsWith('192.168.');
};

/**
 * Gets the current environment type
 * @returns {'production' | 'test' | 'localhost'} Environment type
 */
export const getEnvironmentType = (): 'production' | 'test' | 'localhost' => {
    const currentUrl = window.location.hostname;

    if (isLocalhost()) {
        return 'localhost';
    }

    if (currentUrl.includes('mactest.netkom.it')) {
        return 'test';
    }

    return 'production';
};
